var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalmenteendesacuerdo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f44336;}.cls-2{stroke:#000;stroke-miterlimit:10;stroke-width:13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57,138.61c-.21-1.41-5.53-34.69-38.63-34.79h-.15c-32.72,0-35.27,32.89-35.37,34.29l-13-.86a60.55,60.55,0,0,1,7.06-22.94c5.93-10.72,17.9-23.49,41.27-23.49H83c23.27.07,36.09,12.69,42.75,23.26a64,64,0,0,1,8.71,22.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48.5,
    cy: 54.75,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.5,
    cy: 54.75,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalmenteendesacuerdo);
export default __webpack_public_path__ + "static/media/totalmente en desacuerdo.dbae218327b13621c1f62a98f349a1dd.svg";
export { ForwardRef as ReactComponent };